<template>
  <page>
    <v-flex xs12>
      <form>
        <v-expansion-panels>
          <v-expansion-panel>
            <v-expansion-panel-header>
              <div><v-icon>mdi-filter-variant</v-icon> Filters</div>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-card>
                <v-card-text>
                  <v-container fluid grid-list-lg>
                    <v-layout row wrap>
                      <v-flex xs6 md6>
                        <v-autocomplete
                          :items="pkgRiskSubItemNo"
                          v-model="filters.subItemNo"
                          :label="labels.subItemNo"
                          item-text="label"
                          item-value="value"
                          data-vv-name="subItemNo"
                          :data-vv-as="labels.subItemNo"
                          :error-messages="errors.collect('subItemNo')"
                          clearable
                        ></v-autocomplete>
                      </v-flex>
                      <v-flex xs6 md6>
                        <v-text-field
                          v-model="filters.subItemDesc"
                          :label="labels.subItemDesc"
                          :error-messages="errors.collect('subItemDesc')"
                          data-vv-name="subItemDesc"
                          :data-vv-as="labels.subItemDesc"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs6 md6>
                        <v-text-field
                          v-model="filters.subItemLimit"
                          :label="labels.subItemLimit"
                          :error-messages="errors.collect('subItemLimit')"
                          data-vv-name="subItemLimit"
                          :data-vv-as="labels.subItemLimit"
                          v-num-mask="{ negative: true, intScale: 18, decScale: 2 }"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
                <v-layout row wrap>
                  <v-spacer></v-spacer>
                  <v-card-actions>
                    <v-btn color="red darken-1" text @click.native="doClearFilters">Clear Filters</v-btn>
                    <v-btn color="primary" text type="submit" @click.prevent="doFilters">Apply Filters</v-btn>
                  </v-card-actions>
                </v-layout>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </form>
    </v-flex>
    <v-spacer class="mt-1"></v-spacer>
    <v-card>
      <v-card-title>
        <v-flex xs12>
          <message :messages="messages"></message>
        </v-flex>
        <v-container fluid grid-list-lg>
          <v-layout row wrap>
            <v-flex xs6>
              <v-subheader class="queryLabel">{{ labels.scheme }}</v-subheader>
              <div class="queryValue">{{ pkgRiskItemData.scheme }} - {{ receivedSchemeDesc }}</div>
            </v-flex>
            <v-flex xs6>
              <v-subheader class="queryLabel">{{ labels.planNo }}</v-subheader>
              <div class="queryValue">{{ pkgRiskItemData.planNo }} - {{ receivedPlanDesc }}</div>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs6>
              <v-subheader class="queryLabel">{{ labels.riskNo }}</v-subheader>
              <div class="queryValue">{{ pkgRiskItemData.riskNo }}</div>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-title>
      <v-flex xs12>
        <v-card>
          <v-flex class="text-right">
            <v-btn color="primary" @click.native="doNew">
              <span>{{ lblPkgRiskSubItem }}</span>
              <v-icon right dark>mdi-plus</v-icon>
            </v-btn>
          </v-flex>
          <v-flex xs12>
            <v-card>
              <v-data-table
                v-bind:headers="listPkgRiskSubItem"
                v-bind:items="items"
                :server-items-length="totalItems"
                :footer-props="{'items-per-page-options': itemsPerPage }"
                v-bind:options.sync="pagination"
                item-key="key"
                :loading="loading"
                :no-data-text="noDataText"
              >
                <template v-slot:item="row"
                  ><tr>
                    <td v-for="column in selectedSubItemColumns" :key="column">{{ row.item[column] }}</td>
                    <td class="table-action-header">
                      <table-action :rowData="row" review @review="doReview(row.item)" remove @remove="doPromptRemove(row.item)"></table-action>
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </v-card>
          </v-flex>
        </v-card>
      </v-flex>
    </v-card>
    <confirm v-model="promptRemove" @ok="doDelete">
      <p>Please confirm deletion of this records.</p>
      <div class="queryValue">
        Scheme: {{ selectedPkgSubItem.scheme }}<br />
        Plan No.: {{ selectedPkgSubItem.planNo }}<br />
        Risk No.: {{ selectedPkgSubItem.riskNo }}<br />
        Item No.: {{ selectedPkgSubItem.itemNo }}<br />
        Sub Item No.: {{ selectedPkgSubItem.subItemNo }}
      </div>
    </confirm>
  </page>
</template>

<script>
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import { expandURI, filterQuery } from '@/utils/ajax'
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'

export default {
  data() {
    return {
      toogleArray: [false],
      loading: false,
      pkgRiskSubItemNo: [],
      items: [],
      lblPkgRiskSubItem: 'New Sub Item',
      labels: {
        scheme: 'Scheme',
        planNo: 'Plan No.',
        riskNo: 'Risk No.',
        itemNo: 'Item No.',
        subItemNo: 'Sub Item No.',
        subItemDesc: 'Sub Item Description',
        subItemLimit: 'Sub Item Limit'
      },
      filters: {
        scheme: undefined,
        planNo: undefined,
        riskNo: undefined,
        itemNo: undefined,
        subItemNo: undefined,
        subItemDesc: undefined,
        subItemLimit: undefined
      },
      totalItems: 0,
      selectedPage: 0,
      pagination: {
        sortDesc: [false],
        page: 1,
        itemsPerPage: 5
      },
      selectedSubItemColumns: ['subItemNo', 'subItemDesc', 'subItemLimit'],
      subItemColumns: [
        { text: 'Sub-item No.', value: 'subItemNo' },
        { text: 'Sub-item Description', value: 'subItemDesc' },
        { text: 'Sub-item Limit', value: 'subItemLimit' }
      ],
      promptRemove: false,
      selectedPkgSubItem: {
        scheme: undefined,
        planNo: undefined,
        riskNo: undefined,
        itemNo: undefined,
        subItemNo: undefined
      }
    }
  },
  methods: {
    async doInit() {
      await Promise.all([this.$store.dispatch('packagePlanInit')])
      await Promise.all([this.$store.dispatch('commonsInit')])
      this.getCommonDataList('pkgRiskSubItemNo')
      this.filters.scheme = this.pkgRiskItemData.scheme
      this.filters.planNo = this.pkgRiskItemData.planNo
      this.filters.riskNo = this.pkgRiskItemData.riskNo
      this.filters.itemNo = this.pkgRiskItemData.itemNo
      this.fetchData()
    },
    async fetchData() {
      this.resetMessages()
      const apiURI = this.menu.getPkgRiskSubItemList
      if (apiURI) {
        try {
          this.loading = true
          const { page, itemsPerPage } = this.pagination
          let expand = {
            page: page - 1,
            size: itemsPerPage
          }
          const result = await this.$http.get(filterQuery(expandURI(apiURI, expand), this.filters, this.pagination.sortBy, this.pagination.sortDesc))
          if (result) {
            this.totalItems = result.data.totalElements
            const { data } = result.data
            this.items = []
            if (data) {
              data.map((datamap) => {
                const convertList = {
                  scheme: datamap.scheme,
                  planNo: datamap.planNo,
                  riskNo: datamap.riskNo,
                  itemNo: datamap.itemNo,
                  subItemNo: datamap.subItemNo,
                  subItemDesc: datamap.subItemDesc,
                  subItemLimit: datamap.subItemLimit
                }
                this.items.push(convertList)
              })
            }
          }
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.loading = false
        }
      }
    },
    doClearFilters() {
      this.filters.subItemNo = undefined
      this.filters.subItemDesc = undefined
      this.filters.subItemLimit = undefined
      this.fetchData()
    },
    doFilters() {
      this.fetchData()
    },
    doNew() {
      const commit = {
        tranMode: 'newMode',
        scheme: this.pkgRiskItemData.scheme,
        planNo: this.pkgRiskItemData.planNo,
        riskNo: this.pkgRiskItemData.riskNo,
        itemNo: this.pkgRiskItemData.itemNo
      }
      this.$store.commit('PACKAGERISKSUBITEM_COMMIT_KEY', commit)
      this.$router.push({ name: 'pkgSubItemReview' })
    },
    doReview(data) {
      const commit = {
        tranMode: 'reviewMode',
        scheme: data.scheme,
        planNo: data.planNo,
        riskNo: data.riskNo,
        itemNo: data.itemNo,
        subItemNo: data.subItemNo
      }
      this.$store.commit('PACKAGERISKSUBITEM_COMMIT_KEY', commit)
      this.$router.push({ name: 'pkgSubItemReview' })
    },
    async doDelete() {
      this.resetMessages()
      const apiURI = this.menu.deletePkgRiskSubItem
      if (apiURI) {
        const expand = {
          scheme: this.selectedPkgSubItem.scheme,
          planNo: this.selectedPkgSubItem.planNo,
          riskNo: this.selectedPkgSubItem.riskNo,
          itemNo: this.selectedPkgSubItem.itemNo,
          subItemNo: this.selectedPkgSubItem.subItemNo
        }
        this.$http
          .post(apiURI, expand)
          .then((result) => {
            const data = result.data
            this.notify(data)
            this.promptRemove = false
            this.fetchData()
          })
          .catch((err) => {
            this.promptRemove = false
            const { data } = err.response
            if (data) {
              this.message(data)
            }
          })
      }
    },
    doPromptRemove(data) {
      if (data) {
        this.selectedPkgSubItem.scheme = data.scheme
        this.selectedPkgSubItem.planNo = data.planNo
        this.selectedPkgSubItem.riskNo = data.riskNo
        this.selectedPkgSubItem.itemNo = data.itemNo
        this.selectedPkgSubItem.subItemNo = data.subItemNo
        this.promptRemove = true
      }
    }
  },
  created() {
    this.doInit()
  },
  watch: {
    'pagination': function (value) {
      this.fetchData()
    }
  },
  computed: {
    menu() {
      return this.$store.state.pkgParam.pkgPlan.menu
    },
    pkgRiskId() {
      return this.$store.state.pkgParam.pkgRisk.pkgRiskId
    },
    pkgRiskItemData() {
      return this.$store.state.pkgParam.pkgRiskItem.pkgRiskItemId
    },
    listPkgRiskSubItem() {
      let result = []
      for (const selectedSubItemColumn of this.selectedSubItemColumns) {
        let findCol = this.subItemColumns.find((a) => selectedSubItemColumn === a.value)
        if (findCol) {
          result.push(findCol)
        }
      }
      result.push(TableConst.tableActionHeader)
      return result
    },
    receivedPlanDesc() {
      return this.$store.state.pkgParam.pkgPlan.pkgPlanId.planDesc
    },
    receivedSchemeDesc() {
      return this.pkgRiskId.schemeDesc
    },
    receivedPolTypeDesc() {
      return this.pkgRiskId.polTypeDesc
    }
  },
  mixins: [TableConst.default, MessageMixin, commonAjaxMixin]
}
</script>
